import { Navigate, useLocation } from "react-router-dom";
import { useCustomer } from "../contexts/CustomerContext";

function CustomerProtectedRoute({ children }) {
  const { isAuthorized } = useCustomer();
  const location = useLocation();

   if (isAuthorized === null) {
    return (
  <div className="customer-auth-loading">
    Loading...
  </div>
);
  }

   if (isAuthorized === false) {
    return (
      <Navigate
        to="/support"
        replace
        state={{ from: location.pathname }}
      />
    );
  }

  return children;
}

export default CustomerProtectedRoute;